<template>
  <div>
    <span
      v-for="(playerId, index) in playerIds"
      :key="playerId"
    >
      <player-link
        lable=""
        :playerId="playerId"
      />
      <template v-if="index < playerIds.length-1">, </template>
    </span>
  </div>
</template>

<script>
import PlayerLink from './PlayerLink.vue';

export default {
  name: 'PlayerLinks',

  components: {
    PlayerLink,
  },

  props: {
    playerIds: {
      type: Array,
      required: true,
    },
  },
};
</script>
